// extracted by mini-css-extract-plugin
export default {"container":"CabinInfoSection_container__n-bYf","button":"CabinInfoSection_button__uU1C9","columns":"CabinInfoSection_columns__-Q6H7"};